import AppConfig from "../constants/config";
import { getCookie } from "./getCookie";
import triggerSimpleAjax from "./httpHelper";

const { API_URL, API } = AppConfig;

const getData = (key) => {
  try {
    const item = localStorage.getItem(key);
    if (!item) return null;
    return JSON.parse(item);
  } catch {
    return null;
  }
};

const trackerEvents = (eventname, req = {}, isEs = false) => {
  const intercomUrl = `${API_URL}${API.TRACK_EVENT}`;
  const esUrl = `${API_URL}${API.ES_TRACKER}`;
  const data = getData("vmk_usr");
  const userid = getCookie("userid");
  const { userId } = data || { userId: userid };

  if (!userId) {
    return Promise.resolve(null);
  }

  return new Promise((resolve) => {
    triggerSimpleAjax(
      isEs ? esUrl : intercomUrl,
      "POST",
      true,
      {
        eventname,
        ...req,
        location: window.location.href,
        userId,
      },
      (res) => {
        resolve(res);
      },
      () => {
        resolve(null);
      },
    );
  });
};

export default trackerEvents;
